import { useQuery } from "@tanstack/react-query";
import {
  getOrganization,
  getUsersOrganization,
} from "../../api/organization";

export const ORGANIZATION_QUERY_KEY = ["organization"] as const;
export const ORGANIZATION_USERS_QUERY_KEY = ["organizationUsers"] as const;

export function useOrganization() {
  return useQuery({
    queryKey: ORGANIZATION_QUERY_KEY,
    queryFn: getOrganization,
    staleTime: 30_000,
  });
}

export function useOrganizationUsers() {
  return useQuery({
    queryKey: ORGANIZATION_USERS_QUERY_KEY,
    queryFn: getUsersOrganization,
    staleTime: 0,
  });
}
